import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Select } from "antd";

const states = new Array(
  "Andaman & Nicobar",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra & Nagar Haveli",
  "Daman & Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu & Kashmir",
  "Jharkhand",
  "Karnataka",
  "Keralam",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Orissa",
  "Pondicherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttaranchal",
  "West Bengal",
).map((state) => {
  return { value: state, label: state };
});

const CustomerAddress = ({ address, onSave, onCancel, isSaving }) => {
  const [form] = Form.useForm();

  // Load initial values when prop changes
  useEffect(() => {
    form.setFieldsValue(address);
  }, [address, form]);

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        onSave({ ...address, ...values }); // pass updated fields to parent
      })
      .catch((err) => console.log("Validation failed:", err));
  };

  return (
    <Form form={form} layout="vertical" initialValues={address} style={{ padding: 16 }}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input placeholder="Enter name" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="attention" label="Attention">
            <Input placeholder="Attention (optional)" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="email" label="Email" rules={[{ required: true }, { type: "email", message: "Invalid email" }]}>
            <Input placeholder="Email" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="phone" label="Phone">
            <Input placeholder="Phone" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name="addressLine1" label="Address Line 1" rules={[{ required: true }]}>
        <Input placeholder="Address line 1" />
      </Form.Item>

      <Form.Item name="addressLine2" label="Address Line 2" rules={[{ required: true }]}>
        <Input placeholder="Address line 2" />
      </Form.Item>

      <Form.Item name="addressLine3" label="Address Line 3">
        <Input placeholder="Address line 3" />
      </Form.Item>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="city" label="City" rules={[{ required: true }]}>
            <Input placeholder="City" />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item name="state" label="State" rules={[{ required: true }]}>
            <Select
              showSearch
              style={{
                width: "100%",
              }}
              options={states}
              filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item name="zip" label="ZIP Code" rules={[{ required: true }]}>
            <Input placeholder="ZIP Code" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="GSTIN" label="GSTIN">
            <Input placeholder="GSTIN" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name="country" label="Country" rules={[{ required: true }]}>
        <Input placeholder="Country" disabled />
      </Form.Item>
      <Form.Item>
        <Row justify={"end"}>
          <Button loading={isSaving} disabled={isSaving} onClick={onCancel}>
            Cancel
          </Button>
          <Button loading={isSaving} disabled={isSaving} type="primary" style={{ marginLeft: 10, backgroundColor: "#ae9572", color: "black" }} onClick={handleSave}>
            Save
          </Button>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default CustomerAddress;
